import store from './store'
import Dashboard from './views/Dashboard'
import Editor from './views/Editor'

const install = (Vue, options) => {
  if (!options.store) {
    throw new Error('Please initialize the multi catalogues module with a vuex store.')
  }

  options.store.registerModule('catalogues', store)
}

export default { install, Dashboard, Editor }
